import { useEffect } from 'react';
import Image from '../../../components/image/Image';
import { trackPageView } from '../../../support-and-tracking/analytics-actions';
import ShowGiverdata from './ShowGiverdata';
import { useTitle } from 'hoofd';
import { Heading1, Heading2 } from '@sb1/ffe-core-react';
import { useOutletContext, redirect } from 'react-router';
import { ConsentRequiredWrapper } from './consent-required-wrapper/ConsentRequiredWrapper';
import { useBackgroundColor } from '../useBackgroundColor';
import { SettingsLink } from '../settings-link/SettingsLink';
import fetchJson from '../../../utils/fetch-json';
import { OrganizationControlFeedback } from '../../../components/feedback/OrganizationControlFeedback';
import styles from './organization-giverdata.module.less';

const OrganizationGiverdata = () => {
    const { organization } = useOutletContext();
    useBackgroundColor();

    useEffect(() => {
        trackPageView({
            urlAsEvent: 'subscription-giverdata',
        });
    }, []);

    useTitle('Giverdata');

    return (
        <>
            <div className={styles.organizationDataContainer}>
                <div className={styles.titleAndLink}>
                    <Heading1 lookLike={2} noMargin>
                        Giverdata
                    </Heading1>
                    <SettingsLink to={'./settings'} text={'Innstillinger'} />
                </div>
                <Heading2 lookLike={4} className={styles.title}>
                    Last ned giverdata
                </Heading2>
                <ConsentRequiredWrapper
                    organization={organization}
                    notConsentedBody={
                        <>
                            <Image
                                className={styles.illustrationImage}
                                src="feature-illustrations/taxdeduction-illustration.svg"
                                alt="Illustrasjon av to modaler, hvor én viser at brukere kan velge «ja»/«nei» til å motta nyheter og oppdateringer, og at giverdata kan lastes ned"
                            />
                            <p className={styles.text}>
                                Dere får muligheten til å laste ned data om givere for de som ønsker å bli kontaktet av
                                dere om arbeidet dere gjør eller motta skattefradrag.
                            </p>
                        </>
                    }
                    consentedBody={<ShowGiverdata organizationId={organization?.id} />}
                />
            </div>
            <OrganizationControlFeedback bgColor={'tertiary'} />
        </>
    );
};

export const loader = async ({ dispatch, params, getState, request }) => {
    const { baseURL } = getState();
    const signedResponse = await fetchJson({
        url: `${baseURL}/api/public/organization/${params.organizationId}/giver-data-signed`,
        dispatch,
        getState,
    });
    const hasSigned = signedResponse?.body?.signed;
    const url = new URL(request.url);
    if (!hasSigned && !url.pathname.endsWith('/sign')) {
        return redirect('sign');
    }
};

export default OrganizationGiverdata;
